export const REFI_LIENHOLDER_CONST = {
  LIENHOLDER_BFF_URL: '/protected/942615/applications/',
  HOST_BFF_URL: '/protected/831647/host-app/bff',
  GET_FEATURE_TOGGLE_URL: (featureKey: string) =>
    `/protected/942615/features/${featureKey}`,
  FEATURE_TOGGLES: {
    LIENHOLDER_FEATURE_TOGGLE: '', // update when feature is available for LH
    BFF_POSTAPP_ROUTING: 'bff-postapp-routing-lienholder',
  },
  ASSETS_URL: `${new URL(import.meta.url)?.origin}/assets`,
  BASE_APPLICATION_URL: '/protected/942615/applications/',
  HTTP_HEADERS: {
    Accept: 'application/json;v=2',
    'Content-Type': 'application/json;v=2',
    Cookie: '',
  },
  C1_REFI_APPIDS: 'C1-REFI-APPIDS',
  REFI_SESSION_KEY: 'auto-refi-session',
  REFI_SESSION_KEY_V2: 'refi-app-store',
  API_ERR_MSG:
    'Our system experienced an error. Please try again later. For help right now, you can call us at 1-888-263-4582.',
  CHECKOUT_API_ERR_MSG:
    'Our system experienced an error. Please try again in a few minutes.',
  HASHTAG: '#',
  get isLocalEnv() {
    return window.location.hostname === 'localhost';
  },
  get isDevEnv() {
    return [
      'refi-web-ui-dev.clouddqt.capitalone.com',
      'coaf-lienholder-mfe-dev.clouddqtext.capitalone.com',
      'auto-refi-dev.clouddqt.capitalone.com',
    ].includes(window.location.hostname);
  },
  UI_VARIANT: {
    compareToOldLoan: 'COMPARE_TO_OLD_LOAN',
  },
  REFI_CI_KEY: 'refi-ci',
  ROUTE_CHANGE: 'mfe-internal-route-change',
  ROUTE_CHANGE_EVENT: new CustomEvent('mfe-internal-route-change'),
  MARKETING_ATTRIBUTE_COOKIE: 'afw3', // set in persist-marketing-attributes
  TIMEOUT_IN_MS: 10000,
};
